import { FC, useState } from "react";

import { Button } from "components";
import { ROIModal } from "components";
import { ResaleInfo } from "services/listings/types";

interface ReturnsInfoProps {
  purchasedCurrency: string;
  resaleInfo: ResaleInfo;
}

const ReturnsInfo: FC<ReturnsInfoProps> = ({
  purchasedCurrency,
  resaleInfo,
}) => {
  const [isROIModalOpen, setIsROIModalOpen] = useState(false);

  return (
    <>
      {isROIModalOpen && (
        <ROIModal
          open
          onClose={() => setIsROIModalOpen(false)}
          resaleInfo={resaleInfo}
          currency={purchasedCurrency}
        />
      )}
      <Button
        id="see-my-returns-information"
        variant="contained"
        size="large"
        onClick={() => setIsROIModalOpen(true)}
      >
        See My Returns Information
      </Button>
    </>
  );
};

export default ReturnsInfo;
